import {
  faBrandApple,
  faBrandFacebook,
  faBrandInstagram,
  faBrandLinkedin,
  faBrandTiktok,
  faBrandWhatsapp,
  faBrandXTwitter,
} from '@ng-icons/font-awesome/brands';
import {
  faSolidBold,
  faSolidDownload,
  faSolidEquals,
  faSolidHeading,
  faSolidItalic,
  faSolidLink,
  faSolidListOl,
  faSolidListUl,
  faSolidPersonCircleXmark,
  faSolidQuestion,
  faSolidUnderline,
} from '@ng-icons/font-awesome/solid';
import {
  saxAddBold,
  saxAddCircleBold,
  saxArrowDownBold,
  saxArrowLeft2Bold,
  saxArrowLeft3Bold,
  saxArrowRight2Bold,
  saxArrowUp1Bold,
  saxBankBold,
  saxBuilding4Bold,
  saxCalendar1Bold,
  saxCalendarAddBold,
  saxCallBold,
  saxChart3Bold,
  saxCheckBold,
  saxClipboardTextBold,
  saxClock1Bold,
  saxCloseCircleBold,
  saxCoffeeBold,
  saxDevices1Bold,
  saxDocumentBold,
  saxDocumentSketchBold,
  saxDocumentText1Bold,
  saxDollarCircleBold,
  saxElement3Bold,
  saxEmojiSadBold,
  saxEyeBold,
  saxEyeSlashBold,
  saxFilterBold,
  saxForbiddenBold,
  saxGalleryAddBold,
  saxInfoCircleBold,
  saxLocationBold,
  saxLockBold,
  saxLogoutBold,
  saxMap1Bold,
  saxMessageQuestionBold,
  saxMinusBold,
  saxMinusCircleBold,
  saxMoneysBold,
  saxMoneyTickBold,
  saxMoonBold,
  saxNotificationBingBold,
  saxNotificationBold,
  saxPeopleBold,
  saxPersonalcardBold,
  saxPrinterBold,
  saxProfile2userBold,
  saxRefresh2Bold,
  saxSend2Bold,
  saxSetting2Bold,
  saxShopBold,
  saxShoppingCartBold,
  saxSidebarLeftBold,
  saxSidebarRightBold,
  saxSmsBold,
  saxStatusUpBold,
  saxSun1Bold,
  saxTickCircleBold,
  saxTicketBold,
  saxTicketStarBold,
  saxTimer1Bold,
  saxTrashBold,
  saxTrendUpBold,
  saxUserBold,
  saxWarning2Bold,
} from '@ng-icons/iconsax/bold';
import {
  saxMessageQuestionBulk,
  saxTagCrossBulk,
} from '@ng-icons/iconsax/bulk';
import {
  saxAddCircleOutline,
  saxAddOutline,
  saxArrowDown1Outline,
  saxArrowLeftOutline,
  saxArrowRight3Outline,
  saxArrowUp2Outline,
  saxCalendar1Outline,
  saxClockOutline,
  saxLikeShapesOutline,
  saxMenu1Outline,
  saxMinusCircleOutline,
  saxMinusOutline,
  saxMinusSquareOutline,
  saxRefreshOutline,
  saxSearchNormal1Outline,
  saxTicketOutline,
  saxUserOutline,
} from '@ng-icons/iconsax/outline';

export const ICON_MAP = {
  timer: saxTimer1Bold,
  statusUp: saxStatusUpBold,
  email: saxSmsBold,
  phone: saxCallBold,
  sun: saxSun1Bold,
  moon: saxMoonBold,
  devices: saxDevices1Bold,
  facebook: faBrandFacebook,
  instagram: faBrandInstagram,
  x: faBrandXTwitter,
  tiktok: faBrandTiktok,
  linkedin: faBrandLinkedin,
  userOutline: saxUserOutline,
  ticketOutline: saxTicketOutline,
  menu: saxMenu1Outline,
  eye: saxEyeBold,
  eyeSlash: saxEyeSlashBold,
  ticketStar: saxTicketStarBold,
  ticket: saxTicketBold,
  calendar: saxCalendar1Bold,
  mapPin: saxLocationBold,
  clock: saxClock1Bold,
  check: saxCheckBold,
  coffee: saxCoffeeBold,
  circle: saxAddCircleBold,
  locationOn: saxLocationBold,
  star: saxTicketStarBold,
  trend: saxTrendUpBold,
  organizer: saxPersonalcardBold,
  search: saxSearchNormal1Outline,
  clear: saxTagCrossBulk,
  xMark: saxAddOutline,
  dashboard: saxElement3Bold,
  chart: saxChart3Bold,
  money: saxMoneysBold,
  moneyTick: saxMoneyTickBold,
  shop: saxShopBold,
  arrowUp: saxArrowUp2Outline,
  arrowDown: saxArrowDown1Outline,
  arrowRight: saxArrowRight3Outline,
  bell: saxNotificationBold,
  notificationBell: saxNotificationBingBold,
  trash: saxTrashBold,
  refresh: saxRefresh2Bold,
  left: saxArrowLeft2Bold,
  image: saxGalleryAddBold,
  clockAlt: saxClockOutline,
  calendarAlt: saxCalendar1Outline,
  user: saxUserBold,
  users: saxProfile2userBold,
  document: saxDocumentBold,
  settings: saxSetting2Bold,
  logout: saxLogoutBold,
  dollar: saxDollarCircleBold,
  minus: saxMinusCircleOutline,
  plus: saxAddCircleOutline,
  info: saxInfoCircleBold,
  leftNav: saxSidebarLeftBold,
  rightNav: saxSidebarRightBold,
  close: saxCloseCircleBold,
  tick: saxTickCircleBold,
  loading: saxRefreshOutline,
  cancel: saxMinusCircleBold,
  send: saxSend2Bold,
  file: saxDocumentSketchBold,
  like: saxLikeShapesOutline,
  helpBulk: saxMessageQuestionBulk,
  help: saxMessageQuestionBold,
  filter: saxFilterBold,
  triangleUp: saxArrowUp1Bold,
  triangleDown: saxArrowDownBold,
  question: faSolidQuestion,
  equal: faSolidEquals,
  report: saxDocumentText1Bold,
  city: saxBuilding4Bold,
  cancelPerson: faSolidPersonCircleXmark,
  block: saxForbiddenBold,
  bank: saxBankBold,
  calendarAdd: saxCalendarAddBold,
  warning: saxWarning2Bold,
  addRoundedSquare: saxAddBold,
  minusRoundedSquareOutline: saxMinusSquareOutline,
  minusRoundedSquare: saxMinusBold,
  minusOutline: saxMinusOutline,
  shoppingCart: saxShoppingCartBold,
  rightArrow: saxArrowRight2Bold,
  leftArrow: saxArrowLeft3Bold,
  map: saxMap1Bold,
  clipboard: saxClipboardTextBold,
  lock: saxLockBold,
  arrowLeftOutline: saxArrowLeftOutline,
  sad: saxEmojiSadBold,
  userGroup: saxPeopleBold,
  printer: saxPrinterBold,
  whatsapp: faBrandWhatsapp,
  apple: faBrandApple,
  download: faSolidDownload,
  bold: faSolidBold,
  italic: faSolidItalic,
  underline: faSolidUnderline,
  link: faSolidLink,
  heading: faSolidHeading,
  bulletList: faSolidListUl,
  orderedList: faSolidListOl,
} as const;

export type { IconName } from '@seatix/shared-domain-ui';
